<template>
  <div
    class="b_item_small_box"
    :class="{
      style_2: !isNoBuyStatus,
    }"
    @click="goDetailed(item)"
  >
    <div class="icon_box">
      <img v-lazy="item.iconUrl" class="icon_img" alt="benefit" />
      <img
        v-if="isNoBuyStatus"
        class="icon_lock"
        src="https://img0.didiglobal.com/static/soda_public/do1_FVluH56sfUBQdyQDMTU2"
        alt="lock"
      />
    </div>
    <div class="info_box">
      <h5 class="hyphenate-text">{{ item.title }}</h5>
      <!-- 操作 -->
      <div v-if="!isNoBuyStatus">
        <div v-if="item.receiveStatus === 0" class="btn" @click.stop="goSettingBir">
          {{ $t('FoodC_birthday_MdbO_KlNx') }}
        </div>
        <div v-if="item.receiveStatus === 1" class="btn" @click.stop="getBirthdayCoupons">
          {{ $t('FoodC_birthday_hJRO_UaMS') }}
        </div>
        <div v-if="item.receiveStatus === 3" class="btn" @click.stop="goCoupons">
          {{ $t('FoodC_birthday_vcey_tequ') }}
        </div>
        <div v-if="item.clickUrl" class="btn" @click.stop="jumpBenefit(item)">
          {{ jumpBtnName(item) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mobilityCouponItem, entregaCouponItem } from '@/page/member/common/enumsUtil.js'
import mixin from '@/page/member/mixins.js'

export default {
  name: 'MemberBenefitSmallItem',
  mixins: [mixin],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    goSettingBir() {
      this.$emit('goSettingBir')
    },
    getBirthdayCoupons() {
      this.$emit('getBirthdayCoupons')
    },
    goCoupons() {
      this.$emit('goCoupons')
    },
    goDetailed(data) {
      this.$emit('goDetailed', data)
    },
    jumpBenefit(data) {
      this.$emit('jumpBenefit', data)
    },
    isDeliveryBenefitJump(itemType) {
      // 闪送权益的跳转行为和出行一致，所以将该逻辑收敛到这里
      return itemType === mobilityCouponItem || itemType === entregaCouponItem
    },
    jumpBtnName(data) {
      if (data.clickUrl) {
        return this.$t('FoodC_url_reaV_LXaO')
      }
      return this.$t('FoodC_shoprank_Qwab_yWBb')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/mixin.scss';

.b_item_small_box {
  margin-bottom: 20px;
  width: 227px;
  height: 256px;
  background: #f5f5f7;
  border-radius: 40px;
  &.style_2 {
    height: 300px;
    position: relative;
    .btn {
      position: absolute;
      bottom: 12px;
      display: inline-block;
      padding: 4px 16px;
      background: #ffe5d9;
      border-radius: 25px;
      font-family: DiDiSans-Pro-Bold;
      font-size: 24px;
      color: #ff5f14;
      line-height: 36px;
      font-weight: normal;
      max-width: 170px;
      @include ellipsis(1);
    }
  }
  .icon_box {
    position: relative;
    .icon_img {
      padding-left: 13px;
      padding-top: 32px;
      width: 80px;
      height: 80px;
    }
    .icon_lock {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 32px;
      height: 32px;
    }
  }
  .info_box {
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 16px;
    h5 {
      font-family: DiDiSans-Pro-Bold;
      font-size: 24px;
      color: #0b0b0d;
      line-height: 32px;
      font-weight: normal;
      @include ellipsis(3);
    }
  }
}
</style>
